<template>
  <div class="expected-view">
    <ScreenBg>
      <div class="content">
        <Title>
          <h1>Heute</h1>
          <h1>erwarten</h1>
          <h1>wir</h1>
        </Title>
        <SlidingList
          :persons="$store.getters.expectedPersons"
          v-slot="{ person }"
        >
          <Person :person="person" showPresence :key="person.id" />
        </SlidingList>
      </div>
    </ScreenBg>
    <div class="sidebar-image-container">
      <img class="sidebar-image" src="@/assets/img/Maria.png" />
    </div>
  </div>
</template>

<script>
import ScreenBg from '@/components/ScreenBg.vue';
import SlidingList from '@/components/person-list/SlidingList.vue';
import Person from '@/components/person-list/Person.vue';
import Title from '@/components/Title.vue';

export default {
  name: 'ExpectedView',
  components: {
    ScreenBg,
    Title,
    SlidingList,
    Person,
  },
};
</script>
